import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app-core/services/common.service';
import { SelectEvent, FileRestrictions, RemoveEvent } from '@progress/kendo-angular-upload';
import { finalize } from 'rxjs/operators';
import { CommonDataModel } from '../common-data-model';
import * as _ from 'lodash';

@Component({
  selector: 'app-documents-upload-form',
  templateUrl: './documents-upload-form.component.html',
  styleUrls: ['./documents-upload-form.component.scss']
})
export class DocumentsUploadFormComponent implements OnInit {

  @ViewChild('fileUpload', { static: false }) fileUpload: any;

  commonDataModel = new CommonDataModel();
  uploadBlockFilesExtensions = this.commonDataModel.uploadBlockFilesExtensions;

  isFormLoading = false;
  documentsData: any;
  files: Array<any> = [];
  isUploading = false;
  accountId: any;
  invalidFiles = [];
  invalidAndNewFiles = [];
  validFiles = true;

  constructor(
    private commonService: CommonService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DocumentsUploadFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.accountId = data.accountId;
  }

  ngOnInit() {
    this.documentsData = this.data;
  }

  onSelectEventHandler(e: SelectEvent): void {
    this.checkFileValistions(e.files);
  }


  checkFileValistions(files: any) {
    this.validFiles = true;
    let invalidAndNewFiles = _.cloneDeep([...this.invalidFiles, ...files]);
    this.invalidFiles = [];
    let errorMessage = '', fileNotValidCount = 0, largeFileNameCount = 0;
    const that = this;
    invalidAndNewFiles.forEach((file) => {
      if (!file.validationErrors) {
        if (this.uploadBlockFilesExtensions.indexOf(file.extension) !== -1) {
          this.invalidFiles.push(file);
          fileNotValidCount += 1;
        } else {
          if (file.name.length  > 100) {
            this.invalidFiles.push(file);
            largeFileNameCount += 1;
          } else {
            this.files.push(file);
          }
        }

      }
    });
    if (this.invalidFiles.length) {
      this.validFiles = false;
      let filesCount = 0;
      if (fileNotValidCount) {
        filesCount = fileNotValidCount;
        errorMessage = 'format is not valid';
      } else if (largeFileNameCount) {
        filesCount = largeFileNameCount;
        errorMessage = 'name is to long';
      }
      this.toastr.warning(`${filesCount} ${filesCount === 1 ? 'File' : 'Files'} ${errorMessage}.`);
    }
  }

  onRemoveEventHandler(event: RemoveEvent): void {
    const index = this.files.findIndex(item => item.uid === event.files[0].uid);
    if (index >= 0) {
      this.files.splice(index, 1);
    }
    this.invalidFiles.map((file, index) => {
      if (file.name === event.files[0].name) {
        this.invalidFiles.splice(index, 1);
      }
    });
    this.checkFileValistions([]);
  }

  onUploadEventHandler(event: any) {
    const formData = new FormData();
    this.files.map(item => formData.append('files', item.rawFile, item.name));
    let queryString = `accountId=${this.accountId}&IsAccountDoc=true&TypeId=8`;
    this.isUploading = true;
    this.commonService.orderUploadDocument(formData, queryString)
      .pipe(finalize(() => (this.isUploading = false)))
      .subscribe(response => {
        this.isUploading = false;
        this.toastr.success('Documents uploaded successfully');
        event.clearFiles();
        this.files = [];
        this.dialogRef.close(true);
      });
  }

  onClearFiles(event: any) {
    event.clearFiles();
    this.files = [];
  }

  onSubmit(): void {
    this.dialogRef.close(false);
  }

  onClose(isSuccess?: boolean): void {
    this.dialogRef.close(isSuccess);
  }

}
